import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import PostTemplate from '../../Post/PostComponents/PostTemplate';

function AuthorSavedRecipes({userId}) {

    const [recipes, setRecipes] = useState([])

    useEffect(() => {

        async function fetchRecipes() {

            try {
                const recipesRef = firestore.collection("favorites");
                recipesRef.where("user_id", "==", userId).onSnapshot(({docs}) => {
                    const recipes = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setRecipes(recipes)
                })
            } catch (error) {
                
            }

        }
        fetchRecipes()

    }, [userId])

    return (
        <div className="row">
            {recipes && recipes.map((recipe, index) => {
                return (
                    <PostTemplate 
                        key={index}
                        imageUrl={recipe.recipe_image} 
                        title={recipe.recipe_title} 
                        author={recipe.recipe_author} 
                        postId={recipe.recipe_id}
                    />
                )
            })}
        </div>
    )
}
export default AuthorSavedRecipes